import { Routes, Route } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "./ui/button";
import { ModuleGrid, ModuleDetail } from "./portal";

export const UserPortal = ({ user, onLogout }) => {
  return (
    <div className="min-h-screen bg-cream-50 overflow-x-hidden">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-sage-200">
        <div className="px-4 sm:px-6 py-4">
          <div className="flex items-center justify-end">
            <div className="flex items-center space-x-2 sm:space-x-4">
              <span className="text-xs sm:text-sm text-charcoal-600 hidden md:inline">Vitajte, {user.email}</span>
              <Button 
                onClick={onLogout}
                variant="outline"
                size="sm"
                className="text-charcoal-600 border-sage-200 hover:bg-sage-50"
              >
                <LogOut className="w-4 h-4 sm:mr-2" />
                <span className="hidden sm:inline">Odhlásiť sa</span>
              </Button>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 sm:px-6 py-6 sm:py-8 pb-20 overflow-x-hidden">
        <Routes>
          <Route path="/" element={<ModuleGrid />} />
          <Route path="/modules" element={<ModuleGrid />} />
          <Route path="/module/:id" element={<ModuleDetail />} />
        </Routes>
      </main>
    </div>
  );
};
